import React from 'react';
import LogoIcon from '../../../assets/logo.png';
import './logo.css';

function Logo() {
  return <img src={LogoIcon} alt='Propt1' className='logo'/>
}

export default Logo;
